/**
 * @module @app/providers/app-providers
 * Provider-Komposition der Login-App: TanStack-Query + zentraler
 * GlobalLoginProvider (SDK-Client + Config) + globaler Sonner-Toaster.
 */
import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GlobalLoginProvider } from '@repo/global-login-sdk/react';
import { Toaster } from '@repo/ui/components/ui/sonner';
import { queryClient, supabase } from '@shared/api';
import { globalLoginConfig } from '@shared/config';

/**
 * Umschließt die App mit allen globalen Providern.
 *
 * @param props.children Anwendungsbaum (Router etc.).
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalLoginProvider client={supabase} config={globalLoginConfig}>
        {children}
        <Toaster position="bottom-right" />
      </GlobalLoginProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
